import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=7a222fe7&"
import script from "./Declaration.vue?vue&type=script&lang=js&"
export * from "./Declaration.vue?vue&type=script&lang=js&"
import style0 from "./Declaration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports